<script setup></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 2"
  >
    <path
      fill-rule="nonzero"
      d="M0 0h22v2H0z"
    />
  </svg>
</template>

<style lang="scss" scoped></style>
